import HttpClient from "../helpers/HttpClient"
import EmailTemplate, {EmailTemplateDto} from "./EmailTemplate"
import { HttpError } from "../helpers/Error"

class EmailTemplateService {
    static httpClient = new HttpClient<EmailTemplate, EmailTemplateDto>(EmailTemplate)

    static async get(templateKey: string): Promise<EmailTemplate | EmailTemplate[] | HttpError> {
        return this.httpClient.get(`/templates/${templateKey}/template`)
    }
}

export default EmailTemplateService


// WEBPACK FOOTER //
// ./src/state/mail/EmailTemplateService.ts